module.exports = __webpack_public_path__ + "static/media/15_insideyourblood.c9d100d2.jpg";